import type { Activity } from "@anaconda/core/activity/types"

import { Badge, cn } from "@rarible_int/anaconda_ui_components"

interface Props {
  type: Activity["type"]
}

export function ActivityAction({ type }: Props) {
  return (
    <Badge
      className={cn(
        type === "SELL"
          ? "[&&]:bg-destructive/10 [&&]:text-destructive"
          : "[&&]:bg-success/10 [&&]:text-success",
      )}
    >
      {type}
    </Badge>
  )
}
